import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import cardReader from '../../../../images/card_reader_insert.gif';
import qrCode from '../../../../images/qr_code_new.gif';
import { IKIOSKModel, IkioskMenuIds, IKioskOtherServiceMenu, IKioskMessage, EkioskConfigMessageKeys } from "../../../../models/kioskModel";
import { menuTypeAction, setSelectedLoginOption } from "../../../../store/actions";
import moment from "moment";
import { Modal, ModalBody } from 'reactstrap';
import errorimg from '../../../../images/error.png';
import { Ilanguages } from "../../../../models/utilitiesModel";
import { getLabelConfigMsg } from "../../../../helpers/helpersIndex";

const LoginMenus: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const kioskConfigMsgs: IKioskMessage[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.kioskConfigdata?.kioskMessage || []);
    const authenticationTypes: IKioskOtherServiceMenu[] = useSelector((state: any) => (state?.kioskReducer as IKIOSKModel)?.logInMenus || []);
    const kioskStartTime = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.kioskStartTime || "");
    const kioskEndTime = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.kioskEndTime || "");
    const dateTime = useSelector((state: any) => (state.kioskReducer as IKIOSKModel)?.currentDateAndTime || new Date());
    const startMoment = moment(kioskStartTime, "HH:mm");
    const endMoment = moment(kioskEndTime, "HH:mm");
    const currentMoment = moment(dateTime);
    const isStartTimeExceeded = currentMoment.isSameOrAfter(startMoment, 'minute');
    const isEndTimeExceeded = currentMoment.isSameOrAfter(endMoment, 'minute');
    const startTimeExceed = currentMoment.isBefore(startMoment, 'minute');
    const language: any = useSelector((state) => (state?.kioskReducer as IKIOSKModel)?.language || Ilanguages.ENG);
    console.log('isStartTimeExceeded', { t, isEndTimeExceeded, kioskStartTime, kioskEndTime, dateTime, isStartTimeExceeded, a: moment(dateTime).format('HH'), language, authenticationTypes });
    const handleLogMenu = (menu: IKioskOtherServiceMenu) => {
        if (menu.branchTypeCode === IkioskMenuIds.INPUTMOBILE) {
            dispatch(menuTypeAction(menu.branchTypeCode));
        }
        else {
            dispatch(menuTypeAction(IkioskMenuIds.LANGUGAEPAGE));
            dispatch(setSelectedLoginOption(menu.branchTypeCode));
        }
    }
    return (
        <div className='Kiosk_input'>
            <div className='text-center'>
                {(kioskStartTime && kioskEndTime) && ((isStartTimeExceeded && isEndTimeExceeded) || (startTimeExceed)) &&
                    <>
                        <Modal isOpen={true} className="kiosk_error_modal">
                            <ModalBody>
                                <div className="errorMessage">
                                    <img src={errorimg} alt="" />
                                    <p>{(getLabelConfigMsg(kioskConfigMsgs, language, EkioskConfigMessageKeys.KIOSKNONWORKINGMES) || t('kiosktranslation.timeExpiryMsg')).replace('{starttime}', kioskStartTime ? kioskStartTime : 'N/A').replace('{endtime}', kioskEndTime ? kioskEndTime : 'N/A')}
                                    </p>
                                </div>
                            </ModalBody>
                        </Modal>
                    </>}
                <h2>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ARB, "welcometodubai") || t("kiosktranslation.welcometodubai-Ar")}</h2>
                <h2>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ENG, "welcometodubai") || t("kiosktranslation.welcometodubai")}</h2>
                <div>
                    <h6>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ENG, "proceedsteps") || t("kiosktranslation.proceedsteps")}</h6>
                    <h6>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ARB, "proceedsteps") || t("kiosktranslation.proceedsteps-Ar")}</h6>
                </div>
            </div>
            <div className='equal-width-wrapper d-flex flex-column align-items-start gap-3'>
            {authenticationTypes?.map((menu, index) => (

                <div key={index} onClick={() => handleLogMenu(menu)}>
                    <div className='d-flex flex-column gap-3 pointer'>

                        <div className='input_card'>
                            {menu.branchTypeCode === IkioskMenuIds.INPUTMOBILE && <i className='icon_m42kiosk_mobile'></i>}
                            {menu.branchTypeCode === IkioskMenuIds.NEWPATIENT && <i className="icon_m42kiosk_npatient_registration"></i>}
                            {menu.branchTypeCode === IkioskMenuIds.INSERTEMIRATESID && <img src={cardReader} alt={t("kiosktranslation.insertcard" + language)} width="50" height="auto" />}
                            {menu.branchTypeCode === IkioskMenuIds.SCANQR && <img src={qrCode} alt={t("kiosktranslation.scanqr" + language)} width="50" height="auto" />}
                            <div className='d-flex flex-column'>
                                <strong>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ENG, `${menu.key}`) || t(`kiosktranslation.${menu.key}${Ilanguages.ENG}`)}</strong>
                                <span>{getLabelConfigMsg(kioskConfigMsgs, Ilanguages.ARB, `${menu.key}`) || t(`kiosktranslation.${menu.key}${Ilanguages.ARB}`)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            </div>
        </div>
    )
}
export default React.memo(LoginMenus);